import { useEffect, useRef, useState } from "react";

import { Button, Stack, useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import { HeyTilleyButton } from "mui-toolkit/HeyTilleyButton";

import { CloseIcon, MoreIcon } from "../Icons/Icons";

export default function WorkspaceActionBar({ content }) {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("md"), { noSsr: true });
  const [isOpen, setIsOpen] = useState(false);
  const dialRef = useRef(null);

  const toggleSpeedDial = () => {
    setIsOpen((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dialRef.current && !dialRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Box
      className="navigation workspaceActionBar"
      component={Stack}
      direction="row"
      position="fixed"
      sx={{
        ...{ right: 0 },
        ...(isSmall && { bottom: "1rem", width: "100%", pr: 1, pl: 1 }),
        ...(!isSmall && { top: "1rem", mr: 2 }),
      }}
    >
      {isSmall ? (
        <Stack
          direction="row"
          spacing={1}
          justifyContent="flex-end"
          sx={{
            ...(isSmall && { width: "100%" }),
          }}
        >
          <div ref={dialRef} className="speed-dial-container">
            <HeyTilleyButton isOpen={isOpen} />
            <Button
              className={`speed-dial-trigger ${isOpen ? "openMenu" : ""} `}
              variant="contained"
              sx={{
                boxShadow: (theme) => theme.shadows[2],
              }}
              color={isOpen ? "secondary" : "primary"}
              onClick={toggleSpeedDial}
            >
              {isOpen ? (
                <CloseIcon color="white" className={`speed-dial-icon`} />
              ) : (
                <MoreIcon color="white" className={`speed-dial-icon`} />
              )}
            </Button>
            <div className={`speed-dial-options ${isOpen ? "visible" : "hidden"}`}>{content}</div>
          </div>
        </Stack>
      ) : (
        <Stack
          direction="row"
          spacing={1}
          justifyContent="flex-end"
          sx={{
            ...(isSmall && { width: "100%" }),
          }}
        >
          {content}
          <HeyTilleyButton isOpen={isOpen} />
        </Stack>
      )}
    </Box>
  );
}
